import React from 'react';
import Datatable from '../../ExtraComponents/ReusableTable1';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import { StripHtmlAndTruncate } from "../../Utils/CommonFun";

const History = ({ historyData }) => {
    const DateFormat = (newDate) => {
        if (!newDate) return "-";
        const date = new Date(newDate);
        return format(date, 'eee, MMM d, yyyy h:mm a');
    };

    const columns = [
        {
            name: "History",
            cell: (row) => (
                <div>
                    <p className="mb-1">{row.history}</p>
                    <p className="text-muted small mb-0">{DateFormat(row?.createdAt)}</p>
                </div>
            ),
            selector: (row) => row.history,
            sortable: true,
        },
        {
            name: "Description",
            cell: (row) => {
                const { truncated, isTruncated, fullText } = StripHtmlAndTruncate(row?.description || "");
                return (
                    <div>
                        {truncated}
                        {isTruncated && (
                            <span 
                                className="text-pink cursor-pointer ms-1" 
                                onClick={() => {
                                    Swal.fire({
                                        title: 'Full Description',
                                        text: fullText,
                                        confirmButtonColor: '#ff00a2'
                                    });
                                }}
                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                            >
                                Read More
                            </span>
                        )}
                    </div>
                );
            },
            selector: (row) => row.description,
            sortable: true,
        },
    ];

    return (
        <div className="card mt-2">
            <div className="card-body">
                <section className="section dashboard">
                    <div className="row">
                        <div className='dark-table-thead'>
                            <Datatable
                                columns={columns}
                                data={historyData}
                                filter={false}
                            />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default History;
